"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.eventHistorySchema = void 0;
const yup = __importStar(require("yup"));
const user_schema_1 = require("../user/user.schema");
const logging_action_types_enum_1 = require("../../enums/logging-action-types.enum");
const calendar_event_schema_1 = require("../calendar-event/calendar-event.schema");
const utilities_1 = require("../../utilities");
exports.eventHistorySchema = yup.object().shape({
    id: yup.string().notRequired(),
    eventId: yup.string().notRequired(),
    event: calendar_event_schema_1.calendarEventSchema.required(),
    createdAt: yup.number().min(1577851200000).max(2524622400000).required(),
    person: user_schema_1.userSchema.notRequired().nullable(),
    owner: user_schema_1.userSchema.required().nullable(),
    type: yup.string().required().oneOf((0, utilities_1.getEnumValues)(logging_action_types_enum_1.LoggingActionTypesType)),
});
